import { Outlet, Route } from "react-router-dom";
import { RequireConfig } from "src/components/Permissions/RequireConfig";
import { RequireUserPermissions } from "src/components/Permissions/RequireUserPermissions";
import { useFlags } from "src/components/Providers/FeatureFlagProvider";
import * as Url from "src/services/url";
import { Index } from ".";
import { Configure } from "./Configure";
import { Details } from "./Details";
import { ManageMatchRule } from "./ManageMatchRule";
import { MatchProgress } from "./MatchProgress";
import { MatchProgressFormService } from "./MatchProgressFormService";
import { PublicView } from "./PublicView";
import { ViewMatchRule } from "./ViewMatchRule";

const MatchProgressRoute = () => {
  const flags = useFlags(["form-service-match"]);
  return flags["form-service-match"].enabled ? (
    <MatchProgressFormService />
  ) : (
    <MatchProgress />
  );
};

export const MatchRoutes = (
  <Route
    element={
      <RequireConfig configType="Match">
        <Outlet />
      </RequireConfig>
    }
  >
    <Route
      path={Url.OrgAdmin.Match.indexPath}
      element={
        <RequireUserPermissions permission="match:read">
          <Index />
        </RequireUserPermissions>
      }
    />
    <Route
      path={Url.OrgAdmin.Match.configurePath}
      element={
        <RequireUserPermissions permission="match.configuration:read">
          <Configure />
        </RequireUserPermissions>
      }
    />
    <Route
      path={Url.OrgAdmin.Match.progressPath}
      element={
        <RequireUserPermissions permission="match:read">
          <MatchProgressRoute />
        </RequireUserPermissions>
      }
    />
    <Route
      path={Url.OrgAdmin.Match.detailsPath}
      element={
        <RequireUserPermissions permission="match:read">
          <Details />
        </RequireUserPermissions>
      }
    />

    <Route
      path={Url.OrgAdmin.Match.rulesViewPath}
      element={
        <RequireUserPermissions permission="match.rules:read">
          <ViewMatchRule />
        </RequireUserPermissions>
      }
    />

    <Route
      path={Url.OrgAdmin.Match.rulesEditPath}
      element={
        <RequireUserPermissions permission="match.rules:update">
          <ManageMatchRule />
        </RequireUserPermissions>
      }
    />

    <Route
      path={Url.OrgAdmin.Match.rulesNewPath}
      element={
        <RequireUserPermissions permission="match.rules:create">
          <ManageMatchRule />
        </RequireUserPermissions>
      }
    />

    <Route
      path={Url.OrgAdmin.Match.publicViewPath}
      element={
        <RequireUserPermissions permission="match:read">
          <PublicView />
        </RequireUserPermissions>
      }
    />
  </Route>
);
